import React from 'react';
import { i18n } from '@lingui/core';
import { t, Trans } from '@lingui/macro';
import { P, RadioGroup } from '@decisiv/ui-components';

import useHomeLayout from '../../hooks/useHomeLayout';
import {
  ProfileSection,
  SectionHeader,
  SectionTitle,
  SectionBody,
} from './style';

export default function HomeLayoutSection() {
  const { layout, layouts, setLayout } = useHomeLayout();

  return (
    <ProfileSection>
      <SectionHeader>
        <SectionTitle id="home_layout_title">{t`Home layout`}</SectionTitle>
      </SectionHeader>
      <P color="alaskanHusky" paddingX={2} paddingTop={1}>
        <Trans>How the Integrations home lists your integrations.</Trans>
      </P>
      <SectionBody>
        <RadioGroup
          name="home_layout"
          role="radiogroup"
          aria-labelledby="home_layout_title"
          vertical
          value={layout}
          items={layouts.map(({ id, name, description }) => ({
            value: id,
            label: `${i18n._(name)}: ${i18n._(description)}`,
          }))}
          onChange={(event) => setLayout(event.target.value)}
        />
      </SectionBody>
    </ProfileSection>
  );
}
